import React, { ReactNode } from 'react';
import styles from './page.module.scss';

interface Props {
  children: ReactNode;
}

export default function PageLayout({ children }: Props) {
  return <div className={styles.container}>{children}</div>;
}
